export const featuredBlog = [
  {
    title: "Why We’re Building Agentic Data Portals (Not Just More Dashboards)",
    image: "/assets/images/blog/2026-02-18-agentic-data-portals-chat-first/hero.png",
    href: "https://www.datopian.com/blog/agentic-data-portals-chat-first",
    description: "We explain why chat-first data access in WhatsApp, Telegram, and Slack is becoming the default interaction model, with dashboards as optional on-demand follow-up.",
    authors: ['Anuar-Ustayev.jpg'],
    created: "2026-02-18"
  },
  {
    title: "Why We Decoupled CKAN’s Frontend — And What We Gained with PortalJS",
    image: "https://www.portaljs.com/static/img/blog/2025-05-28-Why-we-decoupled-CKAN%E2%80%99s-frontend/image1.png",
    href: "https://www.portaljs.com/blog/why-we-decoupled-CKAN-frontend",
    description: "We explain why we chose to decouple CKAN’s frontend and how PortalJS made our data portal faster, more flexible, and easier to maintain. A practical look at SSG, serverless scaling, and modern dev workflows with CKAN.",
    authors: ['Yoana-Popova.jpg', 'Anuar-Ustayev.jpg'],
    created: "2025-05-28"
  },
  {
    title: "CKAN 2.12 Is Here — What It Means for the Teams Running CKAN",
    image: "/assets/images/blog/2026-09-03-ckan-2-12-release-guide/hero.png",
    href: "https://www.datopian.com/blog/ckan-2-12-release-guide",
    description: "Discover what's new in CKAN 2.12 — first-class files, faster large datasets, a modern UI, and security fixes every portal team should know.",
    authors: ['Yoana-Popova.jpg'],
    created: "2026-09-03"
  },
]
